<template>
  <div>
    <vs-table stripe :data="operations" noDataText="Nenhum registro encontrado.">

      <template slot="thead">
        <th>Comercializadora</th>
        <th>Cnpj</th>
        <th>Fim</th>
        <th>Serasa</th>
        <th v-for="(month, index) in months" :key="index" > {{ month }}</th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(row, indextr) in data">
          <td>
            <a role="button" style="cursor: pointer" @click="loadChart(row.company)">{{row.company.name}}</a>
          </td>
          <td>
            {{(row.company.cnpjAlfa || row.company.cnpj) | formatCnpj}}
          </td>
          <td>
            <ul>
              <li v-for="(item, index) in row.valuesList" :key="index">
                <span class="font-semibold" style="white-space: nowrap;">{{item}}</span>
              </li>
            </ul>
          </td>
          <td>
            {{row.serasa}}
          </td>
          <td>
            <ul>
              <li v-for="(item, mthIndex) in row.month1" :key="mthIndex">
                {{item | toDecimal}}
              </li>
            </ul>
          </td>
          <td>
            <ul>
              <li v-for="(item, mthIndex)  in row.month2" :key="mthIndex">
                {{item | toDecimal}}
              </li>
            </ul>
          </td>
          <td>
            <ul>
              <li v-for="(item, mthIndex)  in row.month3" :key="mthIndex">
                {{item | toDecimal}}
              </li>
            </ul>
          </td>
          <td>
            <ul>
              <li v-for="(item, mthIndex)  in row.month4" :key="mthIndex">
                {{item | toDecimal}}
              </li>
            </ul>
          </td>
          <td>
            <ul>
              <li v-for="(item, mthIndex)  in row.month5" :key="mthIndex">
                {{item | toDecimal}}
              </li>
            </ul>
          </td>
          <td>
            <ul>
              <li v-for="(item, mthIndex)  in row.month6" :key="mthIndex">
                {{item | toDecimal}}
              </li>
            </ul>
          </td>
          <td>
            <ul>
              <li v-for="(item, mthIndex)  in row.month7" :key="mthIndex">
                {{item | toDecimal}}
              </li>
            </ul>
          </td>
          <td>
            <ul>
              <li v-for="(item, mthIndex)  in row.month8" :key="mthIndex">
                {{item | toDecimal}}
              </li>
            </ul>
          </td>
          <td>
            <ul>
              <li v-for="(item, mthIndex)  in row.month9" :key="mthIndex">
                {{item | toDecimal}}
              </li>
            </ul>
          </td>
          <td>
            <ul>
              <li v-for="(item, mthIndex)  in row.month10" :key="mthIndex">
                {{item | toDecimal}}
              </li>
            </ul>
          </td>
          <td>
            <ul>
              <li v-for="(item, mthIndex)  in row.month11" :key="mthIndex">
                {{item | toDecimal}}
              </li>
            </ul>
          </td>
          <td>
            <ul>
              <li v-for="(item, mthIndex)  in row.month12" :key="mthIndex">
                {{item | toDecimal}}
              </li>
            </ul>
          </td>
          <td>
            <ul>
              <li v-for="(item, mthIndex)  in row.month13" :key="mthIndex">
                {{item | toDecimal}}
              </li>
            </ul>
          </td>
        </vs-tr>
      </template>

    </vs-table>


  </div>
</template>

<script>
export default {
  name: "TraderReportTable",
  props: {
    months: Array,
    operations: Array,
  },
  methods: {
    loadChart (company) {
      this.$emit('cliked', company)
    }
  }
}
</script>

<style scoped>

</style>
